import { createWithEqualityFn as create } from 'zustand/traditional';

interface AdvancedTemplateCategorySelectionStore {
    selectedCategories: string[];
    setSelectedCategories: (selectedCategories: string[]) => void;
}

const useAdvancedTemplateCategorySelection = create<AdvancedTemplateCategorySelectionStore>(
    set => ({
        selectedCategories: ['non-profit'],
        setSelectedCategories: selectedCategories => set({ selectedCategories }),
    }),
);

export { useAdvancedTemplateCategorySelection };
export type { AdvancedTemplateCategorySelectionStore };
